import { validateCtc } from "../../../../utils/ctc";

const validate = async(name,value,formData)=>{
    let error = {status:false,message:''}
    let isField = schema[name];
    const fieldNames = {
        job_title:'Job Title',
        appliedDate:'Applied Date',
        FirstName:'First Name',
        LastName:'Last Name',
        gender:'Gender',
        Email:'Email ID',
        DateOfBirth:'DOB',
        MobileNo:'Contact No',
        candidate_status:'Status',
        location:'Joining Location',
        ScreeningRejectRemark:'Screening Reject Remark',
        CurrentCTC:'Current CTC',
        ExpectedCTC:'Expected CTC',
    };
    if(isField){
        let validation = isField;
        for(let i=0;i<validation.length;i++){
            switch(validation[i]){
                case 'required':
                if(value==''){
                    error = {status:true,message:`${fieldNames[name]} is required`};
                    return error;
                }
                break;
                case 'select':
                 if(!(value?.value)){
                    error = {status:true,message:`${fieldNames[name]} is required`};
                    return error;
                 }   
                break;
                case 'conditional_required':
                    if (String(name) === 'ScreeningRejectRemark' && formData?.candidate_status?.label === "Screening Reject") {
                        if(value == ''){
                            error = {status:true,message:`${fieldNames[name]} is required`};
                            return error;
                        }
                    }
                break;
                case 'ctc':
                    error = validateCtc(value,fieldNames[name]);
                    if(error.status){
                        return error;
                    }
                break;
                case 'conditional_location_required':
                    if (String(name) === 'location' && formData?.candidate_status?.label !== "Screening Reject") {
                        if(value == ''){
                            error = {status:true,message:`${fieldNames[name]} is required`};
                            return error;
                        }
                    }
                break;    
                // case 'min10':
                //     if(!(value?.length!=15)){
                //         error = {status:true,message:`10 digit valid mobile no. required.`};
                //         return error;
                //      }   
                //     break;  

                //     break;
            }
        }
    }
    return error;
}
const schema = {
    job_title:['required'],
    appliedDate:['required'],
    FirstName:['required'],
    LastName:['required'],
    gender:['required'],
    Email:['required'],
    DateOfBirth:['required'],
    MobileNo:['required','min10'],
    candidate_status:['required','select'],
    location:['conditional_location_required'],
    ScreeningRejectRemark:['conditional_required'],
    CurrentCTC:['required','ctc'],
    ExpectedCTC:['required','ctc']
}
export default validate;
